/*
 *  Class Tooltip
 */
export
default class Tooltip {
  constructor() {
    this.tooltipWrapperSelectors = [
      '.teaser__content',
    ];
  }

  getClosestWrapper(el) {
    return el.closest(this.tooltipWrapperSelectors.join(','));
  }

  onOverHandling(e) {
    const tooltip = e.target;
    const tooltipContent = tooltip.querySelector('p');
    if (!tooltipContent) return;
    tooltip.style.top = null;
    const elBB = tooltipContent.getBoundingClientRect();
    const wrapper = this.getClosestWrapper(e.target);
    if (!wrapper) return;
    const wrapperBB = wrapper.getBoundingClientRect();
    const elWrapperDeltaY = elBB.y - wrapperBB.y;
    const newY = wrapperBB.height - elBB.height - elWrapperDeltaY;
    if (newY > 0) return;
    tooltip.style.top = `${newY}px`;
  }

  onOutHandling(e) {
    e.target.style.top = null;
  }

  init() {
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('tooltip__icon')) {
        e.preventDefault();
      }
    });

    const tooltips = document.querySelectorAll('.tooltip');
    for (let tooltip of tooltips) {
      tooltip.addEventListener('mouseenter', this.onOverHandling.bind(this));
      tooltip.addEventListener('mouseleave', this.onOutHandling.bind(this));
    }
  }
}
